import { TOP_BAR_HEIGHT } from 'components/ArcTopBar/constants'
import { createStyles, rem } from 'hooks'

// Arc collapsed rail: prototype width (60px) — a 44px item centered in it
// leaves a symmetric 8px on each side, and the icon axis (x = 30) matches
// the top bar burger column.
export const ARC_SIDEBAR_COLLAPSED_WIDTH = 60

interface SidebarStyleProps {
  collapsed: boolean
  isMobile: boolean
  /** Arc layout: sidebar sits below the fixed 60px top bar (AR-578) */
  arcTopBar: boolean
}

export const useStyles = createStyles((theme, { collapsed, isMobile, arcTopBar }: SidebarStyleProps) => ({
  sidebar: {
    position: 'fixed',
    // Under Arc the burger lives in the top bar, so a collapsed mobile
    // sidebar has nothing to show and is hidden entirely.
    display: arcTopBar && isMobile && collapsed ? 'none' : 'flex',
    top: arcTopBar ? rem(TOP_BAR_HEIGHT) : undefined,
    left: arcTopBar ? 0 : undefined,
    flexDirection: 'column',
    height: arcTopBar
      ? `calc(100% - ${rem(TOP_BAR_HEIGHT)})`
      : isMobile
        ? collapsed
          ? rem(88)
          : '100%'
        : '100%',
    width: collapsed ? rem(arcTopBar ? ARC_SIDEBAR_COLLAPSED_WIDTH : 81) : rem(260),
    backgroundColor: !arcTopBar && isMobile && collapsed
      ? 'transparent'
      : theme.colorScheme === 'dark'
        ? theme.colors.dark[8]
        : theme.white,
    borderRight: !arcTopBar && isMobile && collapsed ? 'none' : `1px solid ${theme.colors.gray[2]}`,
    zIndex: 98,
    transition: 'transform .3s ease-in-out,width .3s ease-in-out',
    boxShadow: !arcTopBar && isMobile && collapsed ? 'none' : '0 0 10px 2px #00000026',
    overflow: 'hidden',
  },
  toggleLogoBox: {
    width: rem(260),
    borderBottom: isMobile
      ? collapsed
        ? ''
        : `1px solid ${theme.colors.gray[2]}`
      : `1px solid ${theme.colors.gray[2]}`,
  },
  menuItems: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    height: '100%',
  },
  listRoot: {
    listStyleType: 'none',
    padding: 0,
    margin: 0,
  },
  // Arc: prototype-style nav — rounded NavLinks with an 8px gutter so the
  // 44px collapsed pill sits perfectly centered in the 60px rail
  arcNavList: {
    display: 'flex',
    flexDirection: 'column',
    gap: rem(4),
    padding: rem(8),
  },
  toggleButtonBox: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: rem(84),
    height: rem(88),
  },
  actionIconToggle: {
    marginLeft: '-6px',
  },
  iconToggle: {
    transform: 'scale(1.2, 1)',
    color: isMobile ? (collapsed ? theme.white : theme.colors.dark[8]) : theme.colors.dark[8],
  },
  iconToggleBack: {
    color: isMobile ? theme.white : theme.colors.dark[8],
  },
}))
